import { authedFetch } from '@/providers/loginWithEmail/dataProvider';

export async function deleteProject(
    projectId: number,
    keepOnedrive: boolean = false
): Promise<void> {
    const queryParam = keepOnedrive ? '?keep_onedrive=true' : '';
    const res = await authedFetch(
        `/projects/${projectId}${queryParam}`,
        { method: 'DELETE' }
    );
    
    // 204 No Content is a success response for DELETE
    if (!res.ok && res.status !== 204) {
        const data = await res.json().catch(() => ({}));
        const message = (data as Record<string, unknown>)?.detail ?? 'Failed to delete project';
        throw new Error(String(message));
    }
}
